import { useEffect } from "react";

const DEFAULT_TITLE = "ShinRai Consulting — Lean, Neurosciences & IA opérationnelle pour dirigeants";

export default function useDocumentTitle(title, description) {
  useEffect(() => {
    const previous = document.title;
    document.title = title ? `${title} · ShinRai Consulting` : DEFAULT_TITLE;
    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (meta) meta.setAttribute("content", description);
    }
    return () => {
      document.title = previous;
    };
  }, [title, description]);
}
